export const driverHiringInitialValues = {
  hiringCompany: { id: 1, title: 'Sierra Expediting Inc.', isDisabled: false },
  name: '',
  ssn: '',
  birthdate: '',
  phone: '',
  email: '',
  currentAddress: '',
  previousAddress: '',
  representative: { name: '', title: '' },
  licenses: [
    { state: '', license: '', type: '', expiration: '' },
  ],
  records: [{ employer: '', from: '', to: '', address: '', phone: '', supervisor: '', position: '', leavingReason: '' }],
  emergencyContacts: [
    { name: '', phone: '', address: '', relation: '' },
  ],
  incidents: [{ date: '', description: '', injuries: '' }],
};

export const ticaInitialValues = {
  name: '',
  type: '',
  phone: '',
  email: '',
  fax: '',
  effectiveDate: '',
  offices: [{ address: '' }],
}